import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

import NavSub from "../components/NavSub";
import { UserContext } from "../context/UserContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MagnifyingGlass, XCircle } from "@phosphor-icons/react";
import {
  Checkbox,
  CircularProgress,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import { AuthContext } from "../context/AuthContext";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { faCaretUp } from "@fortawesome/free-solid-svg-icons";
import HorizontalDateCalender from "./HorizontalDateCalender";
import ToastComponent from "../components/ToastComponent";
import { clientApiUrl, taskApiUrl, reportApiUrl } from "../utils/GetUrl";
import {
  CaretCircleDoubleLeft,
  CaretCircleDoubleRight,
  FileArrowUp,
  FunnelSimple,
} from "phosphor-react";
import isGuestUser, { hasRole } from "../utils/guestUser";
import "../Styles/DailyVoucherStock.css";
import * as XLSX from "xlsx";

const STRStatusReport = () => {
  const {
    teamsData,
    setTeamsData,
    teamNames,
    setTeamNames,
    usersList,
    fetchTeams,
  } = useContext(UserContext);
  const { token, logout, handleAuthExpiry, userData } = useContext(AuthContext);
  // const [selectedDate, setSelectedDate] = useState('');
  // const [chosenDate, setChosenDate] = useState("");
  const [teams, setTeams] = useState(
    teamNames?.filter(
      (team) =>
        team?.superTeamId === 0 && team?.type === "T" && team?.status === true,
    ),
  ); // const [selectedEmployees, setSelectedEmployees] = useState(usersList);
  const [isAccountResponsibleOpen, setIsAccountResponsibleOpen] = useState();
  // const [selectedPrepareName, setSelectedPrepareName] = useState(userData?.[0]);
  const [accSearch, setAccSearch] = useState("");
  const [accountResponsible, setAccountResponsible] = useState([]);
  const [accountResponsible2, setAccountResponsible2] = useState([]);
  const [selectedAccountResponsible, setSelectedAccountResponsible] = useState(
    [],
  );
  const [finalStatusFilter, setFinalStatusFilter] = useState(""); // State to store filter value
  const [searchLoading, setSearchLoading] = useState(false);
  const dropdownsearchRef = useRef(null);
  const toastRef = useRef(null);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [allActivities, setAllActivities] = useState([]);
  const todaysDate = new Date();
  const currentYear = todaysDate.getFullYear();

  const pastYears = Array.from({ length: 4 }, (_, i) => currentYear - i - 1);
  const futureYears = Array.from({ length: 20 }, (_, i) => currentYear + i);
  const allYears = [...pastYears, ...futureYears];
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(
    formatDateToYYYYMM(todaysDate),
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDay, setSelectedDay] = useState(todaysDate.getDate());
  const [expandedActivities, setExpandedActivities] = useState(true);

  const [isTableLoaded, setIsTableLoaded] = useState(false);
  const [query, setQuery] = useState("");
  const [selectedSuggestions, setSelectedSuggestions] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const debounceTimeout = useRef(null);

  function formatDateToYYYYMM(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Add leading zero if necessary
    return `${year}-${month}`;
  }

  const isConsultant = () => {
    if (hasRole(userData?.[0]?.DR_Name, "Consultant")) {
      return true;
    }
    return false;
  };

  const handleYearChange = (event) => {
    const newYear = event.target.value;
    setSelectedYear(newYear);
    fetchReportsFirst(newYear, selectedPrepareNames); // Use array instead of single object
  };
  const fetchSuggestionByText = async () => {
    if (!token) {
      console.error("Token is missing.");
      return;
    }
    try {
      const response = await fetch(
        `${clientApiUrl}/GetAllClient?SearchByText=${query}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error",
        );
        await logout();
        return;
      }

      const handleAuthError = handleAuthExpiry(response);
      if (handleAuthError === true) {
        toastRef.current.showToast("Your Session has expired", "error");
        logout();
        return false;
      }
      if (!response.ok) {
        console.error("Failed to fetch suggestions:", response.statusText);
        setLoading(false);
        return;
      }
      const data = await response.json();
      setSuggestions(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (query.length > 0) {
      setLoading(true);

      debounceTimeout.current = setTimeout(() => {
        fetchSuggestionByText();
      }, 1000);
    } else {
      setSuggestions([]);

      setLoading(false);
    }

    return () => {
      clearTimeout(debounceTimeout.current);
    };
  }, [query]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        dropdownsearchRef.current &&
        !dropdownsearchRef.current.contains(event.target)
      ) {
        setIsSearchOpen(false);
      }
    };

    const handleScroll = () => {
      setIsSearchOpen(false);
    };

    document.addEventListener("mousedown", handleOutsideClick);
    window.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const handleCustomersearchClick = () => {
    setIsSearchOpen(!isSearchOpen);
  };
  useEffect(() => {
    if (isSearchOpen) {
      window.addEventListener("scroll", handleScroll);
    } else {
      window.removeEventListener("scroll", handleScroll);
    }
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isSearchOpen]);
  const handleClearAllSearch = () => {
    // setSelectedSuggestions([]);
    setSelectedModalCustomer(null);
    // setSelectedEmployees([userData?.[0]]);
    setQuery("");
    // setPage(1);
  };

  const handleCheckboxChange = (suggestion) => {
    setSelectedModalCustomer(suggestion);

    // setSelectedSuggestions((prevSelected) => {
    //   if (prevSelected?.some((item) => item.Id === suggestion.Id)) {
    //     return prevSelected.filter((item) => item.Id !== suggestion.Id); // Deselect

    //   } else {
    //     return [suggestion];
    //   }
    // });
  };

  const [selectedOption, setSelectedOption] = useState("");
  const [selectedClient, setSelectedClient] = useState({});

  const [selectedPrepareNames, setSelectedPrepareNames] = useState([]);

  useEffect(() => {
    setAccountResponsible(usersList);
    setAccountResponsible2(usersList);
  }, [usersList]);

  const toggleTeamSelector = () => {
    // setTeamSelectorOpen((prev) => !prev);
  };

  const handleAccountingResponsibleClick = () => {
    // setSelectedOption({});
    // setShowOptions(true);
    setIsAccountResponsibleOpen((prevState) => !prevState);
  };

  const handleChange = (event) => {
    setSelectedPrepareNames();
    //console.log(event.target.value);
    if (event.target.value?.[event.target.value?.length - 1] === undefined) {
      //console.log("mmmmmmmmmmmmmmmm");
      setSelectedTeams([]);
      return;
    }
    setSelectedTeams(event.target.value);
  };
  const handleClearAll = (event) => {
    event.preventDefault();
    setSelectedTeams([]);
  };
  useEffect(() => {
    //console.log(selectedTeams.length);
    if (!selectedTeams?.length) {
      //console.log("this");
      setSelectedEmployees(usersList);
    }
  }, [selectedTeams, token]);

  useEffect(() => {
    const filteredEmployees = usersList?.filter((user) =>
      selectedTeams?.includes(parseInt(user?.STM_Team)),
    );
    setSelectedEmployees(filteredEmployees);

  }, [selectedTeams, usersList, token]);

  const fetchAllActivities = async () => {
    if (!token) return;
    try {
      const response = await fetch(
        `${clientApiUrl}/GetAllActivity?Page=1&ItemsPerPage=100`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error",
        );
        await logout();
        return;
      }

      const handleAuthError = handleAuthExpiry(response);
      if (handleAuthError === true) {
        toastRef.current.showToast("Your Session has expired", "error");
        logout();
        return false;
      }

      if (response.ok) {
        const data = await response.json();

        setAllActivities(
          data?.filter(
            (act) => act?.AL_Type === "Control Point" && act?.AL_Status == "1",
          ),
        );
      } else {
        console.error("Failed to fetch data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (token) {
      fetchAllActivities();
    }
  }, [token]);
  useEffect(() => {
    // Only fetch reports when allActivities is loaded
    if (allActivities.length > 0) {
      fetchReportsFirst(selectedYear, selectedPrepareNames || []);
    }
  }, [allActivities, selectedYear, selectedPrepareNames]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownsearchRef.current &&
        !dropdownsearchRef.current.contains(event.target)
      ) {
        setIsAccountResponsibleOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownsearchRef]);

  const [expanded, setExpanded] = useState(true);

  //fetching data
  const [page, setPage] = useState(1);
  const [masterData, setMasterData] = useState([]);
  const [mergedData, setMergedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [end, setEnd] = useState(false);
  // const [isTableLoaded, setIsTableLoaded] = useState(false);
  const fetchInProgress = useRef(false);

  const formatSelectedEmployees = (selected) => {
    if (!selected || selected.length === 0) return "";
    const emIds = selected.map((item) => `${item["EM_ID"]}`);
    return emIds.join(",");
  };

  useEffect(() => {
    // formatSelectedEmployees(selectedEmployees);
  }, [selectedEmployees, selectedTeams, token]);

  const formatDate = (day, month, year) => {
    // Ensure day and month are always two digits
    const formattedDay = day.toString().padStart(2, "0");
    const formattedMonth = month.toString().padStart(2, "0");

    return `${year}-${formattedMonth}-${formattedDay}`;
  };

  const fetchReportsFirst = async (year, prepareNames, ids) => {
    if (!token) return;
    if (!year) {
      year = new Date().getFullYear();
      setSelectedYear(year);
    }
    try {
      setLoading(true);
      // const allClientIds = await fetchCustomer([]).then(data => data.map(client => client.Id));
      const reportsResponse = await fetch(
        `${reportApiUrl}/GetReports?DteRange1=${year}-01-01&DteRange2=${year}-12-31&Synergyprepare=${formatSelectedEmployees(
          prepareNames && prepareNames.length > 0 ? prepareNames : [],
        )}&ReportType=STR`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (reportsResponse.status === 401) {
        toastRef.current.showToast(
          "Unauthorized access. Please login again.",
          "error",
        );
        await logout();
        return;
      }

      const handleAuthError = handleAuthExpiry(reportsResponse);
      if (handleAuthError) {
        toastRef.current.showToast("Your Session has expired", "error");
        logout();
        return false;
      }

      if (!reportsResponse.ok) throw new Error("Failed to fetch reports");

      const reportsData = await reportsResponse.json();

      // Extract Unique Client IDs
      let clientIdsFromReports = reportsData
        .map((report) => report.ClientId)
        .filter(Boolean);
      clientIdsFromReports = [...new Set(clientIdsFromReports)];

      // Fetch Clients and Tasks
      const clientsData = await fetchCustomer(clientIdsFromReports);
      const tasksData = await fetchTaskTotalTime(
        clientIdsFromReports,
        clientsData,
        year,
      );


      // Merging Logic
      const mergedData = clientsData.map((client) => {
        const taskDataForClient = allActivities.map((activity) => {
          const matchingTask = tasksData.find(
            (task) =>
              task.ActivityId === activity.AL_ID && task.ClientId === client.Id,
          );

          return (
            matchingTask || {
              TotalTime: "0.00",
              ActivityId: activity.AL_ID,
              CreateDate: "",
              ClientId: client.Id,
              TaskStatus: "P",
              AnnualComment: "",
              TaxComment: "",
              BasicComment: "",
            }
          );
        });

        // Combine Comments
        const allComments = [
          ...taskDataForClient.map((task) => task.BasicComment),
          ...taskDataForClient.map((task) => task.TaxComment),
          ...taskDataForClient.map((task) => task.AnnualComment),
        ]
          .filter(Boolean)
          .filter((value, index, self) => self.indexOf(value) === index)
          .join(" ");

        // Find Matching Report
        const matchingReport = reportsData.find(
          (report) => report.ClientId === client.Id,
        );

        // Default Report Fields
        const defaultReportFields = {
          Id: null,
          ReceivedVolume: "",
          PendingVolume: "",
          Volume2: "",
          CommentOfVolume: "",
          PaymentCheck: "",
          PaymentStatus: "",
          CommentOfPaymentFaild: "",
          ReportType: "",
          ReceivedDate: "",
          DueDate: "",
          DateOfSubmission: "",
          ClientId: client.Id,
          CreatedBy: "",
          SynergyPreparer: "",
          CreateDate: "",
        };

        return {
          ...client,
          ...(matchingReport || defaultReportFields),
          tasks: taskDataForClient,
          combinedComments: allComments,
        };
      });

      setMergedData((prev) => {
        if (Array.isArray(selectedEmployees) && selectedEmployees.length > 0) {
          return mergedData;
        }
        return [...(prev ?? []), ...mergedData];
      });

      setIsTableLoaded(true);
    } catch (error) {
      console.error("Error in fetching and merging data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTaskTotalTime = async (clientIds, clientData, year) => {
    if (!clientIds.length) return [];

    const formattedIds = clientIds.map((d) => `'${d}'`).join(",");

    try {
      const response = await fetch(
        `${taskApiUrl}/GetTaskTotalTime?DateRange1=${year}-01-01&DateRange2=${year}-12-31&ClientIds=${formattedIds}&ActivtyType=Control Point`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorized access. Please login again.",
          "error",
        );
        await logout();
        return [];
      }

      if (!response.ok) throw new Error("Failed to fetch task total time");

      const tasksData = await response.json();

      return tasksData;
    } catch (error) {
      console.error("Error fetching task total time:", error);
      return [];
    }
  };

  const fetchCustomer = async (clientIds) => {
    if (!clientIds.length) return [];

    const client = selectedSuggestions?.[0]?.Id;

    try {

      const response = await fetch(
        `${clientApiUrl}/GetAllClient?Page=1&ItemsPerPage=1000${
          client ? `&id=${client}` : `&Ids=${clientIds?.join(",")}`
        }`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorized access. Please login again.",
          "error",
        );
        await logout();
        return [];
      }

      if (!response.ok) throw new Error("Failed to fetch clients");

      const clientsData = await response.json();

      return clientsData;
    } catch (error) {
      console.error("Error fetching customers:", error);
      return [];
    }
  };

  useEffect(() => {
  }, [mergedData]);

  const handleCheckboxAccountResponsibleChange = (acc) => {
    setSelectedAccountResponsible((prev) => {
      let updated;
      if (prev.some((item) => item.EM_ID === acc.EM_ID)) {
        // Remove if already selected
        updated = prev.filter((item) => item.EM_ID !== acc.EM_ID);
      } else {
        // Add if newly checked
        updated = [...prev, acc];
      }

      // Update both states
      setSelectedPrepareNames(updated);
      setSelectedEmployees(updated);

      return updated;
    });
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };
  const handleScroll = debounce(() => {
    const container = document.querySelector(".tablestrreort");

    if (
      container.scrollTop + container.clientHeight >=
      container.scrollHeight
    ) {
      setPage((p) => p + 1);
    }
  }, 1000);

  const isInitialRender = useRef(true);

  useEffect(() => {
    const dateStart = formatDate(selectedDay, selectedMonth, selectedYear);
    const dateEnd = formatDate(selectedDay, selectedMonth, selectedYear);

    if (selectedEmployees > 0) {
      // If SubOwnerEMIDs is passed, fetch all data at once and disable infinite scroll
      fetchCustomer(dateStart, dateEnd, true);
      return;
    }

    fetchCustomer(dateStart, dateEnd, false);
  }, [page, allActivities]);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    setEnd(false);
    setPage(1);
    setMergedData([]);
    setMasterData([]);
    // new Promise(resolve => setTimeout(resolve, 2000));

    if (!selectedEmployees?.length) {
      setSelectedEmployees([userData?.[0]]);
    }

    const dateStart = formatDate(selectedDay, selectedMonth, selectedYear);
    const dateEnd = formatDate(selectedDay, selectedMonth, selectedYear);
    fetchCustomer(dateStart, dateEnd, true);
  }, [
    selectedDay,
    selectedMonth,
    selectedYear,
    selectedEmployees,
    selectedSuggestions,
  ]);

  useEffect(() => {
    if (selectedEmployees > 0) {
      window.removeEventListener("scroll", handleScroll); // Remove scroll listener if fetching all data at once
      return;
    }

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [selectedEmployees]);

  const getUserFirstName = (emId) => {
    const user = usersList?.find((user) => user.EM_ID === emId);
    return user ? user.EM_FirstName + " " + user.EM_LastName : "";
  };

  const debounceRef = useRef(null);

  const handleReportChange = async (data, val, e) => {
    if (isGuestUser(userData?.[0]?.DRM_ID)) {
      toastRef.current.showToast(`Guest User Does not have Add or Edit Access`);

      return;
    }

    const EM_ID = userData?.[0]?.EM_ID; // Assuming userData is coming from context or props

    if (!EM_ID) {
      console.error("Failed to retrieve user ID or Client ID.");
      return;
    }

    // Update the mergedData state with the new value
    const updatedMergedData = mergedData.map((item) => {
      if (item.ClientId === data.ClientId) {
        return { ...item, [val]: e.target.value }; // Dynamically update the field based on val
      }
      return item;
    });

    // Update the state immediately to reflect the change in UI
    setMergedData(updatedMergedData);

    // Prepare the payload based on the updated data
    const updatedItem = updatedMergedData.find(
      (item) => item.ClientId === data.ClientId,
    );

    let payload;
    const isAdding = data.Id === null; // Determine if this is a POST or PUT
    if (isAdding) {
      payload = {
        ClientId: data.ClientId,
        ReceivedVolume: Number(updatedItem.ReceivedVolume) || 0,
        Volume2: Number(updatedItem.Volume2) || 0,
        PendingVolume: Number(updatedItem.PendingVolume) || 0,
        CommentOfVolume: updatedItem.CommentOfVolume || " ",
        PaymentCheck: updatedItem.PaymentCheck || " ",
        PaymentStatus: updatedItem.PaymentStatus || " ",
        CommentOfPaymentFaild: updatedItem.CommentOfPaymentFaild || " ",
        ReportType: "STR",
        ReceivedDate: updatedItem?.ReceivedDate || "",
        DueDate: updatedItem?.DueDate || "",
        DateOfSubmission: todaysDate,
        CreatedBy: EM_ID,
        SynergyPreparer: updatedItem?.SynergyPreparer,
      };
    } else {
      payload = {
        TaskReportId: data.Id,
        ClientId: data.ClientId,
        ReceivedVolume: Number(updatedItem.ReceivedVolume) || 0,
        Volume2: Number(updatedItem.Volume2) || 0,
        PendingVolume: Number(updatedItem.PendingVolume) || 0,
        CommentOfVolume: updatedItem.CommentOfVolume || "",
        PaymentCheck: updatedItem.PaymentCheck || "",
        PaymentStatus: updatedItem.PaymentStatus || "",
        CommentOfPaymentFaild: updatedItem.CommentOfPaymentFaild || "",
        ReportType: "STR",
        ReceivedDate: updatedItem?.ReceivedDate || "",
        DueDate: updatedItem?.DueDate || "",
        DateOfSubmission: todaysDate,
        CreatedBy: EM_ID,
        SynergyPreparer: updatedItem?.SynergyPreparer,
      };
    }

    // Throttle API calls to once every 1 second
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(async () => {
      try {
        const url = isAdding
          ? `${reportApiUrl}/AddTaskReport` // POST URL
          : `${reportApiUrl}/UpdateTaskReport`; // PUT URL

        const method = isAdding ? "POST" : "PUT";

        const response = await fetch(url, {
          method,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Assuming `token` is defined elsewhere
          },
          body: JSON.stringify(payload),
        });

        if (response.status === 401) {
          toastRef.current.showToast(
            "Unauthorised access. Please login again.",
            "error",
          );
          await logout();
          return;
        }

        const handleAuthError = handleAuthExpiry(response);
        if (handleAuthError === true) {
          toastRef.current.showToast("Your Session has expired", "error");
          logout();
          return false;
        }

        if (response.ok) {
          const result = await response.json();

          if (isAdding) {
            // Fetch the report of the client only after adding
            const reportResponse = await fetch(
              `${reportApiUrl}/GetReports?ClientId='${data.ClientId}'&DteRange1=${selectedYear}-01-01&DteRange2=${selectedYear}-12-31`,
              {
                method: "GET",
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              },
            );

            if (response.status === 401) {
              toastRef.current.showToast(
                "Unauthorised access. Please login again.",
                "error",
              );
              await logout();
              return;
            }

            const handleAuthError = handleAuthExpiry(response);
            if (handleAuthError === true) {
              toastRef.current.showToast("Your Session has expired", "error");
              logout();
              return false;
            }

            if (reportResponse.ok) {
              const reportData = await reportResponse.json();

              // Update mergedData with reportId
              const updatedMergedDataWithReportId = mergedData.map((item) => {
                if (item.ClientId === data.ClientId) {
                  return {
                    ...item,
                    Id: reportData?.[0]?.Id, // Update the Id field with the reportData Id
                    SynergyPreparer:
                      updatedItem?.SynergyPreparer || item.SynergyPreparer,
                    ReceivedDate:
                      updatedItem?.ReceivedDate || item.ReceivedDate,
                    DueDate: updatedItem?.DueDate || item.DueDate,
                  };
                }
                return item;
              });

              setMergedData(updatedMergedDataWithReportId);
            } else {
              console.error(
                "Failed to fetch report data:",
                reportResponse.statusText,
              );
            }
          }
        } else {
          console.error(
            `Error ${method === "POST" ? "adding" : "updating"} data:`,
            response.statusText,
          );
        }
      } catch (error) {
        console.error("Error making API call:", error);
      } finally {
        debounceRef.current = null;
      }
    }, 1000); // Debounce delay of 1 second
  };
  const [isDownloading, setIsDownloading] = React.useState(false);
  const handleDownload = async () => {
    if (!token) return;

    if (isGuestUser(userData?.[0]?.DRM_ID)) {
      toastRef.current.showToast(`Guest User Does not have Add or Edit Access`);
      return;
    }

    try {
      setIsDownloading(true); // start spinner
      // Filter the data based on current UI filters
      const filteredData = mergedData.filter(
        (i) =>
          (i?.ClientId ||
            selectedAccountResponsible?.some(
              (acc) => acc?.Id === i?.ClientId,
            )) &&
          (finalStatusFilter === "" ||
            calculateFinalStatus(i) === finalStatusFilter),
      );

      if (filteredData.length === 0) {
        toastRef.current.showToast("No data to export", "info");
        return;
      }

      // Prepare data for Excel
      const worksheetData = filteredData.map((data) => {
        const row = {
          "Customer Name": data.Name,
          "Project Number": data.ProjectNumber || "N/A",
        };

        // Add expanded columns if they're visible in UI
        if (expanded) {
          row["ERP System"] = data.ERPSystem || "N/A";
          row["Cost Center"] = data.CostCenter || data.CostCenterName || "N/A";
          row["Department"] = data.Department || data.DepartmentName || "N/A";
          row["Department Head"] = data.HODName || "N/A";
          row["Account Owner"] = data.OwnerEMId || "N/A";
          row["Team Lead"] = data.LeadId || "N/A";
          row["Average Time"] = data.STRActivityAverageTime || "N/A";
        }

        // Add common columns
        row["Synergy Preparer"] =
          getUserFirstName(data.SynergyPreparer) || "N/A";
        row["Received Date"] = data.ReceivedDate || "";
        row["Due Date"] = data.DueDate || "";

        // Add activity columns if they're visible in UI
        if (expandedActivities) {
          allActivities.forEach((act) => {
            const task = data.tasks?.find((t) => t.ActivityId === act.AL_ID);
            const statusDisplay =
              task?.TaskStatus === "R"
                ? "No"
                : task?.TaskStatus === "A"
                  ? "Yes"
                  : "Pending";

            row[act.AL_Name] = statusDisplay;
          });
        }

        // Add remaining columns
        row["Comments"] = data.combinedComments || "No comments available";
        row["Date of Submission"] = calculateDateOfSubmission(
          data.CreateDate,
          data.tasks,
        );
        row["STRActivityAverageTime"] = data.STRActivityAverageTime || "N/A";
        row["Standard Time"] = calculateStandardTime(data);
        row["Actual Time"] = calculateActualTime(data);
        row["Preparation Progress"] = calculateProgress(data);
        row["Final Status"] = calculateFinalStatus(data);

        return row;
      });

      // Create workbook and worksheet
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(worksheetData);

      // Calculate column widths based on content
      const colWidths = [];
      const maxWidth = 190; // Maximum width for columns

      // Calculate appropriate column widths
      worksheetData.forEach((row) => {
        Object.values(row).forEach((value, colIndex) => {
          const valueLength = value ? value.toString().length : 0;
          const headerLength = Object.keys(row)[colIndex].length;
          const cellLength = Math.max(valueLength, headerLength);

          // Set width with max constraint
          if (!colWidths[colIndex] || cellLength > colWidths[colIndex].width) {
            colWidths[colIndex] = {
              width: Math.min(maxWidth, Math.max(10, cellLength + 2)),
            };
          }
        });
      });

      worksheet["!cols"] = colWidths;

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "STR Status Report");

      // Generate Excel file
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create download link
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `STR_Status_Report_${selectedYear}.xlsx`;
      document.body.appendChild(link);
      link.click();

      // Clean up
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);

      toastRef.current.showToast(
        "Excel file downloaded successfully",
        "success",
      );
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      toastRef.current.showToast("Error exporting to Excel", "error");
    } finally {
      setIsDownloading(false); // stop spinner
    }
  };
  // Inline spinner style
  const spinnerStyle = {
    width: "14px",
    height: "14px",
    border: "2px solid #ccc",
    borderTop: "2px solid #3d025f",
    borderRadius: "50%",
    animation: "spin 0.7s linear infinite",
  };

  // Inject keyframes for animation (only once)
  React.useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }, []);

  const calculateDateOfSubmission = (createDate, tasks) => {
    // Check if all tasks have a status of "R" or "A"
    const allTasksHaveValidStatus = tasks?.every(
      (task) => task?.TaskStatus === "R" || task?.TaskStatus === "A",
    );

    // If all tasks have status "R" or "A", display the CreateDate
    if (allTasksHaveValidStatus) {
      return formatDateCreated(createDate);
    } else {
      return null; // Do not display Date of Submission if there are tasks with status "P" or empty
    }
  };

  const calculateStandardTime = (data) => {
    const approvedTasks = data?.tasks?.filter(
      (task) => task.TaskStatus === "A",
    );
    return approvedTasks?.length * 10 || 0; // 10 could be the standard time per task
  };

  const calculateActualTime = (data) => {
    const totalTime =
      data?.tasks?.reduce(
        (sum, task) => sum + parseFloat(task.TotalTime || 0),
        0,
      ) || 0;
    const standardTime = calculateStandardTime(data); // Get standard time from approved tasks

    const roundedTotalTime = Math.round(totalTime);
    const roundedStandardTime = Math.round(standardTime);


    return roundedTotalTime; // Return the rounded value
  };

  const calculateProgress = (data) => {
    const totalTasks = data?.tasks?.length || 0;
    const approvedTasks =
      data?.tasks?.filter((task) => task.TaskStatus === "A").length || 0;
    const rejectedTasks =
      data?.tasks?.filter((task) => task.TaskStatus === "R").length || 0;
    const tasksWithApprovedOrRejected = approvedTasks + rejectedTasks;
    const progress =
      totalTasks > 0
        ? ((tasksWithApprovedOrRejected / totalTasks) * 100).toFixed(2) + "%"
        : "0%";

    return progress;
  };

  const calculateFinalStatus = (data) => {
    const hasYes = data?.tasks?.some((task) => task.TaskStatus === "A");
    const hasNo = data?.tasks?.some((task) => task.TaskStatus === "R");
    const hasPending = data?.tasks?.some((task) => task.TaskStatus === "P");
    const hasEmpty = data?.tasks?.some((task) => !task.TaskStatus);
    if ((hasYes || hasNo) && !hasPending && !hasEmpty) {
      return "Completed";
    }
    return "Not Completed";
  };

  useEffect(() => {
  }, [allActivities]);
  const formatDateCreated = (date) => {
    if (!date) return "";
    const formattedDate = new Date(date);
    const year = formattedDate.getFullYear();
    const month = (formattedDate.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-indexed
    const day = formattedDate.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  useEffect(() => {
    const tableContainer = document.querySelector(".table_STR");

    if (tableContainer) {
      let isDown = false;
      let startX;
      let scrollLeft;

      const handleMouseDown = (e) => {
        isDown = true;
        tableContainer.classList.add("active");
        startX = e.pageX - tableContainer.offsetLeft;
        scrollLeft = tableContainer.scrollLeft;
      };

      const handleMouseLeave = () => {
        isDown = false;
        tableContainer.classList.remove("active");
      };

      const handleMouseUp = () => {
        isDown = false;
        tableContainer.classList.remove("active");
      };

      const handleMouseMove = (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - tableContainer.offsetLeft;
        const walk = (x - startX) * 2; // Adjust multiplier for speed
        tableContainer.scrollLeft = scrollLeft - walk;
      };

      tableContainer.addEventListener("mousedown", handleMouseDown);
      tableContainer.addEventListener("mouseleave", handleMouseLeave);
      tableContainer.addEventListener("mouseup", handleMouseUp);
      tableContainer.addEventListener("mousemove", handleMouseMove);

      return () => {
        tableContainer.removeEventListener("mousedown", handleMouseDown);
        tableContainer.removeEventListener("mouseleave", handleMouseLeave);
        tableContainer.removeEventListener("mouseup", handleMouseUp);
        tableContainer.removeEventListener("mousemove", handleMouseMove);
      };
    }
  }, []);

  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsSearchOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [selectedCustomerData, setSelectedCustomerData] = useState(null);
  const [selectedModalCustomer, setSelectedModalCustomer] = useState(null); // State only for modal
  const [selectedPreparer, setSelectedPreparer] = useState("");
  const [selectedReceivedDate, setSelectedReceivedDate] = useState("");
  const [selectedDueDate, setSelectedDueDate] = useState("");

  const handleExecuteReport = async (selectedCustomerData) => {

    if (!selectedCustomerData || !selectedCustomerData.Id) {
      console.error("No customer selected or ClientId is missing");
      return;
    }
    const EM_ID = userData?.[0]?.EM_ID;

    if (!EM_ID) {
      console.error("Failed to retrieve user ID or Client ID.");
      return;
    }

    // Check if customer already exists in mergedData
    const isCustomerExists = mergedData?.some(
      (data) => data.ClientId === selectedCustomerData.Id,
    );

    if (isCustomerExists && toastRef.current) {
      // toastRef.current.showToast("Customer name is already there in the data");
      toastRef.current.showToast(
        `${selectedCustomerData.Name} Customer name is already Exist`,
      );
      return;
    }
    const payload = {
      ClientId: selectedCustomerData.Id,
      ReceivedVolume: Number(selectedCustomerData.ReceivedVolume) || 0,
      Volume2: Number(selectedCustomerData.Volume2) || 0,
      PendingVolume: Number(selectedCustomerData.PendingVolume) || 0,
      CommentOfVolume: selectedCustomerData.CommentOfVolume || "",
      PaymentCheck: selectedCustomerData.PaymentCheck || "",
      PaymentStatus: selectedCustomerData.PaymentStatus || "",
      CommentOfPaymentFaild: selectedCustomerData.CommentOfPaymentFaild || "",
      ReportType: "STR",
      ReceivedDate: selectedReceivedDate,
      DueDate: selectedDueDate,
      DateOfSubmission: todaysDate,
      CreatedBy: EM_ID,
      SynergyPreparer: selectedPreparer,
    };

    try {
      const response = await fetch(`${reportApiUrl}/AddTaskReport`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error",
        );
        await logout();
        return;
      }

      const result = await response.json();
      if (response.ok) {

        // Show success message
        toastRef.current.showToast(
          `Report for ${selectedModalCustomer.Name} added successfully`,
          "success",
        );

        // Fetch updated reports
        fetchReportsFirst(selectedYear, selectedPrepareNames);

        // Close modal after successful submission
        closeModal();

        // Reset form fields
        setSelectedModalCustomer(null);
        setSelectedPreparer("");
        setSelectedReceivedDate("");
        setSelectedDueDate("");
        setQuery("");
      } else {
        console.error("Failed to add report:", response.statusText);
      }
    } catch (error) {
      console.error("Error making API call:", error);
    }
  };

  return (
    <div>
      <NavSub />
      <ToastComponent ref={toastRef} timeout={4000} />

      <div
        style={{
          display: "flex",
          gap: "28px",
          padding: "20px 24px",
          width: "98%",
          margin: "1rem auto",
          background: "white",
          borderRadius: "10px",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", gap: "28px" }}>
          <div
            className="Title-STR-main2"
            onClick={handleAccountingResponsibleClick}
          >
            {selectedAccountResponsible.length > 0
              ? selectedAccountResponsible
                  .map((acc) => `${acc.EM_FirstName} ${acc.EM_LastName}`)
                  .join(", ")
              : "Preparer Name"}
            <FontAwesomeIcon
              className="str-caret-icon"
              icon={isAccountResponsibleOpen ? faCaretUp : faCaretDown}
            />
            {isAccountResponsibleOpen && !isConsultant() && (
              <div ref={dropdownsearchRef} className="search-drop-STRReport">
                <div className="search-drop-page">
                  <div className="main-suggestion">
                    <div className="input-suggestion">
                      <div className="icon-search-phospher">
                        <MagnifyingGlass
                          size={20}
                          color="#ada4a4"
                          weight="fill"
                        />
                      </div>
                      <input
                        type="text"
                        value={accSearch}
                        className="input-suggestion-search"
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => {
                          const value = e.target.value.toLowerCase();
                          setAccSearch(value);
                          setAccountResponsible2(
                            accountResponsible?.filter((acc) =>
                              (acc.EM_FirstName + " " + acc?.EM_LastName)
                                .toLowerCase()
                                .includes(value),
                            ),
                          );
                        }}
                        placeholder="Start typing..."
                      />
                    </div>
                    <div tabIndex={1}>
                      <div
                        style={{
                          color: "#B00000",
                          padding: "2px 22px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          const empty = [];
                          setSelectedPrepareNames(empty);
                          setSelectedAccountResponsible(empty);
                          setSelectedEmployees(empty);
                          fetchReportsFirst(selectedYear, empty); // 🔄 Fetch with empty preparers
                        }}
                      >
                        Clear All
                      </div>
                      {accountResponsible2?.map((acc) => (
                        <div
                          key={acc.EM_ID}
                          className="suggestion-list-li"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <input
                            type="checkbox" // Changed from radio to checkbox
                            className="radio-searchbox" // Updated class name
                            style={{
                              accentColor: "rgb(80, 20, 90)",
                              width: "18px",
                              height: "18px",
                            }}
                            checked={selectedAccountResponsible?.some(
                              (item) => item.EM_ID === acc?.EM_ID,
                            )}
                            onChange={() =>
                              handleCheckboxAccountResponsibleChange(acc)
                            }
                          />
                          <label className="li-content">
                            {acc.EM_FirstName + " " + acc.EM_LastName}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="Title-STR-main2" onClick={openModal}>
            Add Reports
          </div>
          {isModalOpen && (
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-black bg-opacity-50">
              <div className="modalLayout">
                <div className="modalLayout_contact">
                  <div className="modalLayoutMain_contact-STR">
                    <div className="modalStyling flex flex-col gap-8">
                      <div className="flex justify-between-reports">
                        <div className="text-lg font-semibold text-left font-poppins leading-36 text-custom-purple">
                          Add Customer Reports
                        </div>
                        <XCircle
                          onClick={closeModal}
                          size={32}
                          weight="fill"
                          className="text-rgba-243-237-255"
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gap: "12px",
                          border: "1px solid #000",
                          padding: "12px",
                        }}
                      >
                        Select Customer Name
                        <FunnelSimple
                          className="icon-search-dropdown"
                          onClick={handleCustomersearchClick}
                          weight="bold"
                          size={20}
                          color="#061347"
                        />
                        {isSearchOpen && (
                          <div
                            className="search-drop-design-report"
                            ref={dropdownRef}
                          >
                            <div className="search-drop-page">
                              <div className="main-suggestion">
                                <div className="input-suggestion">
                                  <input
                                    type="text"
                                    value={query}
                                    className="input-suggestion-search"
                                    onChange={(e) => setQuery(e.target.value)}
                                    placeholder="Start typing..."
                                  />
                                  <button
                                    className="clear-title"
                                    onClick={handleClearAllSearch}
                                  >
                                    Clear All
                                  </button>
                                </div>
                                {suggestions.map((suggestion) => (
                                  <div
                                    key={suggestion.Id}
                                    className="suggestion-list-li"
                                  >
                                    <input
                                      type="checkbox"
                                      className="check-searchbox"
                                      checked={
                                        selectedModalCustomer?.Id ===
                                        suggestion.Id
                                      }
                                      onChange={() => {
                                        handleCheckboxChange(suggestion);
                                        setSelectedPreparer("");
                                        setSelectedReceivedDate("");
                                        setSelectedDueDate("");
                                        setSelectedCustomerData(suggestion);
                                        //  setIsSearchOpen(false);
                                      }}
                                    />
                                    <label className="li-content">
                                      {suggestion.Name}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      {selectedModalCustomer && (
                        <table className="w-full mt-4 border-collapse">
                          <thead>
                            <tr className="bg-custom-purple text-white">
                              <th className="p-2 text-left w-1/4">
                                Customer Name
                              </th>
                              <th className="p-2 text-left w-1/4">
                                Synergy Preparer
                              </th>
                              <th className="p-2 text-left w-1/4">
                                Received Date
                              </th>
                              <th className="p-2 text-left w-1/4">Due Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="bg-white border-b">
                              <td className="p-2 text-left font-poppins">
                                {selectedModalCustomer.Name}
                              </td>
                              <td className="p-2">
                                <select
                                  className="w-full p-2 border rounded-lg bg-white"
                                  value={selectedPreparer || ""}
                                  onChange={(e) =>
                                    setSelectedPreparer(e.target.value)
                                  }
                                >
                                  <option value="" disabled>
                                    Select Preparer
                                  </option>
                                  {usersList?.map((u) => (
                                    <option key={u.EM_ID} value={u.EM_ID}>
                                      {u.EM_FirstName + " " + u.EM_LastName}
                                    </option>
                                  ))}
                                </select>
                              </td>
                              <td className="p-2">
                                <input
                                  type="date"
                                  className="w-full p-2 border rounded-lg text-custom-green font-bold"
                                  value={selectedReceivedDate || ""}
                                  onChange={(e) =>
                                    setSelectedReceivedDate(e.target.value)
                                  }
                                />
                              </td>
                              <td className="p-2">
                                <input
                                  type="date"
                                  className="w-full p-2 border rounded-lg text-custom-green font-bold"
                                  value={selectedDueDate || ""}
                                  onChange={(e) =>
                                    setSelectedDueDate(e.target.value)
                                  }
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      )}
                      <button
                        className="mt-4 p-2 bg-custom-purple text-white rounded-lg hover:bg-purple-700"
                        onClick={() =>
                          handleExecuteReport(selectedCustomerData)
                        }
                      >
                        Execute Report
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "24px" }}
        >
          <div
            className="Nav-btn-user"
            onClick={!isDownloading ? handleDownload : null}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: isDownloading ? "not-allowed" : "pointer",
            }}
          >
            {isDownloading ? (
              <>
                <div style={spinnerStyle}></div>
                <button
                  className="Nav-Sub-btn"
                  style={{ opacity: 0.6 }}
                  disabled
                >
                  DOWNLOADING...
                </button>
              </>
            ) : (
              <>
                <FileArrowUp size={25} color="#3d025f" weight="fill" />
                <button className="Nav-Sub-btn">DOWNLOAD FILES</button>
              </>
            )}
          </div>
          <div className="dropdown_year">
            <label htmlFor="yearSelect"></label>
            <select
              id="yearSelect"
              value={selectedYear}
              onChange={handleYearChange}
              style={{ padding: "5px", fontFamily: "Poppins" }}
            >
              {allYears.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div
        style={{
          width: "98%",
          margin: "1rem auto",
          height: "calc(100vh - 250px)", // Fixed height (adjust as needed)
          overflow: "auto",
          position: "relative",
          scrollbarWidth: "auto", // For Firefox
          scrollbarColor: "#888 transparent", // For Firefox
          // WebKit scrollbar styling
          "&::-webkit-scrollbar": {
            width: "16px", // Horizontal scrollbar height
            height: "16px", // Vertical scrollbar width
          },
          "&::-webkit-scrollbar-thumb": {
            borderRadius: "6px",
          },
        }}
        className="table_STR"
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",

            fontFamily: "Arial, sans-serif",
            border: "1px solid #ddd",
          }}
          className="tablestrreort"
        >
          <thead
            style={{
              position: "sticky",
              top: 0,
              zIndex: 10,
              background: "white",
            }}
          >
            <tr>
              <th
                style={{
                  position: "sticky",
                  left: 0,
                  top: 0,
                  zIndex: 20,
                }}
                className="header-customername"
              >
                <div
                  style={{
                    display: "flex",

                    alignItems: "center",
                    gap: "16px",
                  }}
                >
                  Customer Name
                </div>
              </th>
              <th
                style={{
                  backgroundColor: "#D9D9D9",
                  color: "#000",
                  minWidth: "200px",
                  textAlign: "start",
                  position: "sticky",
                  top: 0, // stick to top
                  left: 300, // push right after Customer Name (adjust to match Customer Name width)
                  zIndex: 19, // slightly below Customer Name (which has zIndex: 20)
                }}
              >
                {" "}
                Project Number
                <span
                  style={{
                    position: "absolute",
                    minWidth: "150px",
                    right: "-115px",
                    top: "20px",
                    color: "black",
                    cursor: "pointer",
                  }}
                  onClick={() => setExpanded(!expanded)}
                >
                  {" "}
                  {expanded ? (
                    <CaretCircleDoubleRight size={32} color="#080808" />
                  ) : (
                    <CaretCircleDoubleLeft size={32} color="#080808" />
                  )}
                </span>
              </th>
              {expanded && (
                <th
                  style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    minWidth: "150px",
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                  }}
                >
                  ERP System
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Cost Center
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Department{" "}
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Department Head{" "}
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  View Account Owner
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  View Team Lead{" "}
                </th>
              )}
              {expanded && (
                <th
                  className="Expand-styles"
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 10,
                  }}
                >
                  Average Time
                </th>
              )}

              <th
                className="last-portion-style"
                style={{
                  position: "sticky",
                  top: 0,
                  background: "white",
                  zIndex: 10,
                }}
              >
                Synergy Preparer
              </th>
              <th
                className="last-portion-style"
                style={{
                  position: "sticky",
                  top: 0,
                  background: "white",
                  zIndex: 10,
                }}
              >
                Received Date
              </th>
              <th
                style={{
                  background: "white",
                  color: "#000",
                  // position: "relative",
                  minWidth: "200px",
                  textAlign: "start",
                  position: "sticky",
                  top: 0,
                  zIndex: 10,
                }}
              >
                Due Date
                <span
                  style={{
                    position: "absolute",
                    minWidth: "150px",
                    right: "-110px",
                    top: "20px",
                    color: "black",
                    cursor: "pointer",
                  }}
                  onClick={() => setExpandedActivities(!expandedActivities)}
                >
                  {expandedActivities ? (
                    <CaretCircleDoubleRight size={32} color="#080808" />
                  ) : (
                    <CaretCircleDoubleLeft size={32} color="#080808" />
                  )}
                </span>
              </th>

              {expandedActivities &&
                allActivities?.map((act) => (
                  <th
                    className="Expand-styles"
                    key={act.AL_ID}
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                      minWidth: "355px",
                    }}
                  >
                    {act.AL_Name}
                  </th>
                ))}
              <th
                className="last-portion-style"
                style={{ position: "sticky", top: 0, zIndex: 10 }}
              >
                Comments
              </th>
              <th
                className="last-portion-style"
                style={{ position: "sticky", top: 0, zIndex: 10 }}
              >
                Date of Submission
              </th>
              <th
                className="last-portion-style"
                style={{ position: "sticky", top: 0, zIndex: 10 }}
              >
                STRActivityAverageTime
              </th>
              <th
                className="last-portion-style"
                style={{ position: "sticky", top: 0, zIndex: 10 }}
              >
                Standard Time
              </th>
              <th
                className="last-portion-style"
                style={{ position: "sticky", top: 0, zIndex: 10 }}
              >
                Actual Time
              </th>
              <th
                className="last-portion-style"
                style={{ position: "sticky", top: 0, zIndex: 10 }}
              >
                Preparation progress
              </th>
              <th
                className="last-portion-style"
                style={{ position: "sticky", top: 0, zIndex: 10 }}
              >
                {" "}
                <div style={{ marginBottom: "10px" }}>
                  <select
                    value={finalStatusFilter}
                    onChange={(e) => setFinalStatusFilter(e.target.value)}
                    style={{
                      padding: "10px",
                      fontFamily: "Poppins",
                      background: "none",
                      border: "none",
                      outline: "none",
                      appearance: "none", // Hides default arrow
                      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='28' height='28' fill='black'%3E%3Cpath d='M10 18h4v-2h-4v2zm-7-6v2h18v-2H3zm3-8v2h12V4H6z'/%3E%3C/svg%3E")`,
                      backgroundSize: "15px",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "right 10px center",
                      cursor: "pointer",
                      width: "170px",
                    }}
                  >
                    <option value="">Final Status</option>
                    <option value="Completed">Completed</option>
                    <option value="Not Completed">Not Completed</option>
                  </select>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {mergedData?.filter(
              (i) =>
                (i?.ClientId ||
                  selectedAccountResponsible?.some(
                    (acc) => acc?.Id === i?.ClientId,
                  )) &&
                (finalStatusFilter === "" ||
                  calculateFinalStatus(i) === finalStatusFilter),
            )?.length > 0 ? (
              mergedData
                ?.filter(
                  (i) =>
                    (i?.ClientId ||
                      selectedAccountResponsible?.some(
                        (acc) => acc?.Id === i?.ClientId,
                      )) &&
                    (finalStatusFilter === "" ||
                      calculateFinalStatus(i) === finalStatusFilter),
                )
                .map((data, index) => (
                  <tr
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "#F1F1F1" : "#FFFFFF",
                    }}
                  >
                    <td
                      style={{
                        padding: "15px",
                        fontFamily: "Poppins",
                        background: index % 2 === 0 ? "#F1F1F1" : "#FFFFFF",
                        position: "sticky",
                        left: 0,
                        top: 110,

                        zIndex: 15,
                      }}
                    >
                      {data?.Name}
                    </td>

                    <td
                      style={{
                        padding: "15px",
                        fontFamily: "Poppins",
                        background: index % 2 === 0 ? "#F1F1F1" : "#FFFFFF",
                        position: "sticky",
                        left: 300, // same offset as header
                        top: 110,
                        zIndex: 14, // below header
                      }}
                    >
                      {data?.ProjectNumber || "N/A"}
                    </td>
                    {expanded && (
                      <>
                        <td
                          style={{
                            padding: "15px",
                            border: "1px solid #fff",
                            fontFamily: "Poppins",
                          }}
                        >
                          {data?.ERPSystem || "N/A"}
                        </td>
                        <td
                          style={{
                            padding: "15px",
                            border: "1px solid #fff",
                            fontFamily: "Poppins",
                          }}
                        >
                          {selectedSuggestions?.length > 0
                            ? data?.CostCenterName
                            : data?.CostCenter}
                        </td>
                        <td
                          style={{
                            padding: "15px",
                            border: "1px solid #fff",
                            fontFamily: "Poppins",
                          }}
                        >
                          {selectedSuggestions?.length > 0
                            ? data?.DepartmentName
                            : data?.Department}
                        </td>
                        <td
                          style={{
                            padding: "15px",
                            border: "1px solid #fff",
                            fontFamily: "Poppins",
                          }}
                        >
                          {data?.HODName || "N/A"}
                        </td>
                        <td
                          style={{
                            padding: "15px",
                            border: "1px solid #fff",
                            fontFamily: "Poppins",
                          }}
                        >
                          {data?.OwnerEMId || "N/A"}
                        </td>
                        <td
                          style={{
                            padding: "15px",
                            border: "1px solid #fff",
                            fontFamily: "Poppins",
                          }}
                        >
                          {data?.LeadId || "N/A"}
                        </td>
                        <td
                          style={{
                            padding: "15px",
                            border: "1px solid #fff",
                            fontFamily: "Poppins",
                          }}
                        >
                          {data?.STRActivityAverageTime || "N/A"}
                        </td>
                      </>
                    )}
                    <td>
                      <select
                        style={{
                          padding: "10px",
                          width: "100%",
                          background: "none",
                        }}
                        value={data?.SynergyPreparer || ""}
                        onChange={(e) =>
                          handleReportChange(data, "SynergyPreparer", e)
                        }
                      >
                        <option value="" disabled>
                          Select Preparer
                        </option>
                        {usersList?.map((u) => (
                          <option key={u.EM_ID} value={u.EM_ID}>
                            {u.EM_FirstName + " " + u.EM_LastName}
                          </option>
                        ))}
                      </select>
                    </td>

                    <td>
                      <input
                        type="date"
                        style={{
                          padding: "10px",
                          background: "none",
                          color: "#00763B",
                          fontWeight: "bold",
                          border: "none",
                          outline: "none",
                        }}
                        value={data?.ReceivedDate || ""}
                        onChange={(e) =>
                          handleReportChange(data, "ReceivedDate", e)
                        }
                      />
                    </td>

                    <td>
                      <input
                        type="date"
                        style={{
                          padding: "10px",
                          background: "none",
                          color: "#00763B",
                          fontWeight: "bold",
                          border: "none",
                          outline: "none",
                        }}
                        value={data?.DueDate || ""}
                        onChange={(e) => handleReportChange(data, "DueDate", e)}
                      />
                    </td>

                    {expandedActivities &&
                      (data?.tasks || allActivities).map((act) => {
                        const statusDisplay =
                          act?.TaskStatus === "R"
                            ? "No"
                            : act?.TaskStatus === "A"
                              ? "Yes"
                              : "Pending";

                        const statusColor =
                          act?.TaskStatus === "R"
                            ? "#B00000" // No
                            : act?.TaskStatus === "A"
                              ? "#00763B" // Yes
                              : "#898989"; // Pending

                        return (
                          <td
                            key={act?.ActivityId}
                            style={{
                              minWidth: "250px",
                              textAlign: "start",
                              paddingLeft: "20px",
                              color: statusColor, // Set the color dynamically
                            }}
                          >
                            {statusDisplay}
                          </td>
                        );
                      })}

                    <td
                      style={{
                        padding: "15px",
                        fontFamily: "Poppins",
                        maxHeight: "60px",
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                      }}
                    >
                      {data?.combinedComments || "No comments available"}
                    </td>

                    <th
                      className="last-portion-style"
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "#F1F1F1" : "#FFFFFF",
                        color: "#898989",
                      }}
                    >
                      {calculateDateOfSubmission(data?.CreateDate, data?.tasks)}
                    </th>
                    <td
                      style={{
                        padding: "15px",

                        fontFamily: "Poppins",
                      }}
                    >
                      {data?.STRActivityAverageTime || "N/A"}
                    </td>
                    <th
                      className="last-portion-style"
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "#F1F1F1" : "#FFFFFF",
                        color: "#898989",
                      }}
                    >
                      {calculateStandardTime(data)}
                    </th>
                    <th
                      className="last-portion-style"
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "#F1F1F1" : "#FFFFFF",
                        color: "#898989",
                      }}
                    >
                      {calculateActualTime(data)}
                    </th>
                    <th
                      className="last-portion-style"
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "#F1F1F1" : "#FFFFFF",
                        color: "#898989",
                      }}
                    >
                      {calculateProgress(data)}
                    </th>
                    <th
                      className="last-portion-style"
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "#F1F1F1" : "#FFFFFF",
                        color:
                          calculateFinalStatus(data) === "Completed"
                            ? "#00763B"
                            : "#B00000",
                      }}
                    >
                      {calculateFinalStatus(data)}
                    </th>
                  </tr>
                ))
            ) : (
              <tr>
                <td
                  colSpan="10"
                  style={{
                    textAlign: "center",
                    padding: "15px",
                    fontFamily: "Poppins",
                    color: "#898989",
                  }}
                >
                  No reports available
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {loading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px",
            }}
          >
            <CircularProgress style={{ color: "purple" }} width={40} />
          </div>
        )}
        {end && <div>No more Data...</div>}
      </div>
    </div>
  );
};

export default STRStatusReport;
